/* ==========================================================================
   BONPEK BABY - COLLECTION DESCRIPTION CLAMP (enhancement only)
                                                               25 Sep 2026
   --------------------------------------------------------------------------
   Pairs with assets/bonpek-collection-head.css and the markup in
   snippets/section-main-collection.liquid.

   THIS SCRIPT DOES NOT DO THE CLAMPING. The CSS clamps on first paint so the
   grid never jumps; read that file's header for why. All this does is the
   one thing CSS cannot: notice that a description is ALREADY SHORTER than
   two lines and take the Read more control away, because offering to expand
   text that is fully visible makes the page look broken.

   So if this file fails to load, or JavaScript is off, the page still works:
   the description is clamped and the checkbox still opens it. Nothing here
   is load-bearing.

   MEASURING HAS TO WAIT FOR THE WEBFONT. scrollHeight taken before the
   collection font swaps in is measured in the fallback face and can be a
   line out, which would hide the control on a description that does need it.
   document.fonts.ready handles that where it exists; the load event is the
   fallback.
   ========================================================================== */
(function () {
  'use strict'

  var FITS = 'bpk-cdesc--fits'
  var SLACK = 4 // px of rounding tolerance

  function measure(wrap) {
    var rte = wrap.querySelector('.rte--collection-desc')
    var input = wrap.querySelector('.bpk-cdesc__input')
    if (!rte) return

    // Never judge while the customer has it open - scrollHeight and
    // clientHeight are equal then and everything looks like it fits.
    if (input && input.checked) return

    wrap.classList.remove(FITS)
    var overflowing = rte.scrollHeight - rte.clientHeight > SLACK
    if (!overflowing) wrap.classList.add(FITS)
  }

  function all() {
    var wraps = document.querySelectorAll('[data-bpk-collection-desc]')
    for (var i = 0; i < wraps.length; i++) measure(wraps[i])
  }

  var pending = null
  function schedule() {
    if (pending) return
    pending = window.requestAnimationFrame(function () {
      pending = null
      all()
    })
  }

  function boot() {
    all()
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(all).catch(function () {})
    }
    window.addEventListener('load', all)
    window.addEventListener('resize', schedule)
    window.addEventListener('orientationchange', schedule)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot)
  } else {
    boot()
  }
})()
